import React from "react";
import Modal from "react-modal";

export const HeaderModal = ({
  show,
  modalCopy,
  handleClose,
  handleExit,
  handleExitCopy,
  customOverlayStyles
}: {
  show: boolean;
  modalCopy: string;
  handleClose: () => void;
  handleExit: () => void;
  handleExitCopy: string;
  customOverlayStyles: object;
}) => {
  Modal.setAppElement("body");

  const customStyles = {
    content: {
      outline: 0
    },
    overlay: {
      background: "transparent",
      inset: "0px",
      paddingTop: "48px",
      ...customOverlayStyles
    }
  };

  return (
    <Modal
      isOpen={show}
      className="modal ch-shadow--xs ch-mh--auto ch-bg--white ch-pa--4"
      style={customStyles}
    >
      <p className="exit-warning ch-color--ac-black ch-fs--3 ch-text--center ch-mh--auto ch-mb--0">
        {modalCopy}
      </p>
      <div className="ch-display--flex ch-justify-content--center ch-pt--3">
        <button
          className="ch-btn button ch-fs--2 ch-mr--1 ch-pa--0 ch-width--12 sm:ch-width--auto"
          type="button"
          onClick={handleClose}
        >
          Stay here
        </button>
        <button
          className="ch-btn ch-btn--primary button ch-fs--2 ch-ml--1 ch-pa--0 ch-width--12 sm:ch-width--auto"
          type="button"
          onClick={handleExit}
        >
          {handleExitCopy}
        </button>
      </div>
    </Modal>
  );
};
